<nz-modal (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [(nzVisible)]="isVisible" nzTitle="Add New Customer">
  <ng-container *nzModalContent>
    <section id="renterDetails">
      <nz-card>
        <div>
          <h5 class="text-primary">Renter's Details</h5>

          <form [formGroup]="customerForm" [nzLayout]="'vertical'" nz-form>
            <div class="mt-5 grid md:grid-cols-1 gap-2">
              <div class="grid sm:grid-cols-1" formGroupName="renterDetails">

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="fullName" nzRequired>Full Name</nz-form-label>
                  <nz-form-control [nzErrorTip]="fullName">
                    <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                      <ng-template #addOnBeforeTemplate>
                        <nz-select class="surname-select" formControlName="title" nzPlaceHolder="Select"
                        >
                          <nz-option nzLabel="Mr." nzValue="MR"></nz-option>
                          <nz-option nzLabel="Mrs." nzValue="MRS"></nz-option>
                          <nz-option nzLabel="Miss." nzValue="MISS"></nz-option>
                        </nz-select>
                      </ng-template>
                      <input [maxLength]="70" class="full-name-input" formControlName="fullName" nz-input
                             placeHolder="Enter Full Name" type="text"/>
                    </nz-input-group>
                  </nz-form-control>
                  <ng-template #fullName>
                <span
                  *ngIf="customerForm.get('renterDetails.fullName').hasError('required')">Please enter Customer Name</span>
                    <span *ngIf="customerForm.get('renterDetails.fullName').hasError('maxlength')">
                  Maximum length is 70 characters</span>
                    <span *ngIf="customerForm.get('renterDetails.fullName').hasError('pattern')">
                  Only allowed letters, please avoid adding special characters or numbers</span>
                  </ng-template>
                </nz-form-item>
              </div>


              <div class="grid gap-2" formGroupName="renterDetails">

                <nz-form-item [ngClass]="{'has-error': customerForm.get('renterDetails.contactNo').invalid && customerForm.get('renterDetails.contactNo').touched}"
                              class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="contactNo" nzRequired>Contact Number (Home Country)</nz-form-label>
                  <nz-form-control [nzErrorTip]="mobileNo">
                    <nz-input-group [nzAddOnBefore]="addOnBeforeDailCodeTemplate">
                      <ng-template #addOnBeforeDailCodeTemplate>
                        <nz-select class="country-code-select" formControlName="dailCode" nzPlaceHolder="Select"
                                   (nzOnSearch)="onSearchDailCode($event)"  nzAllowClear nzShowSearch>
                          <nz-option *ngFor="let data of this.filteredCountryDailCodeData" nzLabel="{{data.dial_code}}"
                                     nzValue="{{data.code}}"></nz-option>
                        </nz-select>
                      </ng-template>
                      <input [maxLength]="15" formControlName="contactNo" nz-input placeHolder="Enter Mobile Number"
                             type="text"/>
                    </nz-input-group>
                  </nz-form-control>
                  <ng-template #mobileNo>
                    <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('required')">Please Enter Mobile Number</span>
                    <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('maxlength')"> Maximum length is 15 characters</span>
                    <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                  </ng-template>
                </nz-form-item>


                  <nz-form-item [ngClass]="{'has-error': customerForm.get('renterDetails.email').invalid && customerForm.get('renterDetails.email').touched}"
                                class="grid grid-flow-row content-start">
                    <nz-form-label nzFor="contactNo">Email</nz-form-label>
                    <nz-form-control [nzErrorTip]="email">
                      <input formControlName="email" nz-input placeHolder="Enter email"
                             type="text"/>
                    </nz-form-control>
                    <ng-template #email>
                      <span *ngIf="customerForm.get('renterDetails.email').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                      <span
                        *ngIf="customerForm.get('renterDetails.email').hasError('email')&& customerForm.get('renterDetails.email').touched">Invalid email address, please review your input.</span>
                    </ng-template>
                  </nz-form-item>
<!--                <nz-form-item [ngClass]="{'has-error': customerForm.get('renterDetails.email').invalid && customerForm.get('renterDetails.email').touched}" class="grid grid-flow-row content-start">-->
<!--                  <nz-form-label nzFor="contactNo">Email</nz-form-label>-->
<!--                  <nz-form-control [nzErrorTip]="email">-->
<!--                    <input formControlName="email" nz-input placeholder="Enter email" type="text"/>-->
<!--                  </nz-form-control>-->
<!--                  <ng-template #email>-->
<!--                    <span *ngIf="customerForm.get('renterDetails.email').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>-->
<!--                    <span *ngIf="customerForm.get('renterDetails.email').hasError('email') && customerForm.get('renterDetails.email').touched">Invalid email address, please review your input.</span>-->
<!--                  </ng-template>-->
<!--                </nz-form-item>-->

              </div>

            </div>

            <div class=" grid md:grid-cols-1 gap-2">
              <div class="grid sm:grid-cols-1" formGroupName="renterDetails">
                <div>
                  <label class="mt-2">Home Address</label>
                  <nz-form-item class="mt-2">
                    <nz-form-control>
                      <nz-textarea-count [nzMaxCharacterCount]="300">
                <textarea PlaceHolder="Home Address" formControlName="homeAddress" nz-input
                          rows="2"></textarea>
                      </nz-textarea-count>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div class="grid  md:grid-cols-1 lg:grid-cols-2 gap-2" formGroupName="renterDetails">


                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="homeCountry" nzRequired>Home Country</nz-form-label>
                  <nz-form-control [nzErrorTip]="homeCountry">
                    <nz-select (nzOnSearch)="onSearchHomeCountry($event)" formControlName="homeCountry" nzAllowClear
                               nzPlaceHolder="Select" nzRequired nzShowSearch>
                      <nz-option *ngFor="let data of this.filteredCountryData" nzLabel="{{data.name}}"
                                 nzValue="{{data.name}}"></nz-option>

                    </nz-select>
                  </nz-form-control>
                  <ng-template #homeCountry>
                  <span
                    *ngIf="formErrors.renterDetails.homeCountry.required">Please Enter Home Country </span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item *ngIf="this.customerForm.get('renterDetails.homeCountry').value === 'Other'"
                              class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="otherCountry">Other Country</nz-form-label>
                  <nz-form-control>
                    <input [maxLength]="70" formControlName="otherCountry" nz-input placeHolder="Other Country"
                           type="text"/>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-2" formGroupName="renterDetails">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="dob">Date of Birth</nz-form-label>
                <nz-form-control [nzErrorTip]="dob">
                  <nz-date-picker class="w-full"
                                  formControlName="dob"></nz-date-picker>
                </nz-form-control>
                <ng-template #dob>
        <span
          *ngIf="formErrors.renterDetails.dob.required">Please Enter Date of Birth </span>
                </ng-template>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="birthCity">Birth City</nz-form-label>
                <nz-form-control>
                  <input [maxLength]="70" formControlName="birthCity" nz-input placeHolder="Birth City" type="text"/>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="birthCountry">Birth Country</nz-form-label>
                <nz-select (nzOnSearch)="onSearchBirthCountry($event)" formControlName="birthCountry" nzAllowClear
                           nzPlaceHolder="Select" nzRequired nzShowSearch>
                  <nz-option *ngFor="let data of this.filteredBirthCountryData" nzLabel="{{data.name}}"
                             nzValue="{{data.name}}"></nz-option>
                </nz-select>
              </nz-form-item>

            </div>
          </form>
        </div>
      </nz-card>
    </section>


    <section class="mt-8" id="passportLicenceDetails">
      <nz-card>
        <div>
          <h5 class="text-primary">Passport/Licence Details</h5>

          <form [formGroup]="customerForm" [nzLayout]="'vertical'" nz-form>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-2" formGroupName="passportLicenceDetails">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="passportNo">Passport Number</nz-form-label>
                <nz-form-control [nzErrorTip]="PassNo">
                  <input (input)="checkExisting($event)" [maxLength]="70" formControlName="passportNo" nz-input
                         placeHolder="Passport Number"
                         type="text"/>
                </nz-form-control>
                <ng-template #PassNo>
        <span
          *ngIf="passExists">Passport number already exists </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="issueDatePass">Issued Date</nz-form-label>
                <nz-form-control [nzErrorTip]="issueDatePass">
                  <nz-date-picker class="w-full"
                                  formControlName="issueDatePass"></nz-date-picker>
                </nz-form-control>
                <ng-template #issueDatePass>
        <span
          *ngIf="formErrors.passportLicenceDetails.issueDatePass.required">Please Enter Passport Issued Date </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="expiryDatePass">Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="expiryDatePass">
                  <nz-date-picker [nzDisabledDate]="pastDateDisabled" class="w-full"
                                  formControlName="expiryDatePass"></nz-date-picker>
                </nz-form-control>
                <ng-template #expiryDatePass>
        <span
          *ngIf="formErrors.passportLicenceDetails.expiryDatePass.required">Please Passport Expiry Date </span>
                </ng-template>
              </nz-form-item>


            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-2" formGroupName="passportLicenceDetails">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="drivingLicenceNo">Driving Licence Number</nz-form-label>
                <nz-form-control>
                  <input [maxLength]="70" formControlName="drivingLicenceNo" nz-input placeHolder="Driving Licence Number"
                         type="text"/>
                </nz-form-control>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="issueDateLicence">Issued Date</nz-form-label>
                <nz-form-control [nzErrorTip]="issueDateLicence">
                  <nz-date-picker class="w-full"
                                  formControlName="issueDateLicence"></nz-date-picker>
                </nz-form-control>
                <ng-template #issueDateLicence>
        <span
          *ngIf="formErrors.passportLicenceDetails.issueDateLicence.required">Please Enter Licence Issued Date </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="expiryDateLicence">Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="expiryDateLicence">
                  <nz-date-picker [nzDisabledDate]="pastDateDisabled" class="w-full"
                                  formControlName="expiryDateLicence"></nz-date-picker>
                </nz-form-control>
                <ng-template #expiryDateLicence>
        <span
          *ngIf="formErrors.passportLicenceDetails.expiryDateLicence.required">Please Licence Expiry Date </span>
                </ng-template>
              </nz-form-item>


            </div>

            <div class="mt-5 grid md:grid-cols-1 gap-4">

              <div>
                <p class="pb-[8px] font-semibold" style="color:#9A9A9A">Attachments</p>
                <p class="pb-[6px] font-normal">Passport/Licence</p>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                  <div>
                    <nz-upload
                      (cancel)="passportLicenceUploading = false" [nzCustomRequest]="upload" [nzMultiple]="false"
                      [nzShowUploadList]="false">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="passportLicenceUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of passportLicenceFiles; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a href="{{file.url}}" target="_blank">{{ file.name }}</a>
                      <span (nzOnConfirm)="confirmRemoveAttachment(i)" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'" class="cursor-pointer"
                            nz-icon
                            nz-popconfirm nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            nzTheme="outline"
                            nzType="close-circle"
                      ></span>
                    </div>
                  </div>
                </div>


                <!--            <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"-->
                <!--                       class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
                <!--              <button nz-button>-->
                <!--                <span nz-icon nzType="upload"></span>-->
                <!--                Click to Upload-->
                <!--              </button>-->
                <!--            </nz-upload>-->
                <!--            <div *ngFor="let file of passportLicenceFiles;let i = index">-->
                <!--              <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
                <!--                                                                                  nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
                <!--                                                                                  nzPopconfirmPlacement="bottom"-->
                <!--                                                                                  (nzOnConfirm)="confirmRemoveAttachment(i)"-->
                <!--                                                                                  (nzOnCancel)="cancel()"nzTheme="outline"></span></a>-->
                <!--            </div>-->
              </div>

            </div>
          </form>
        </div>
      </nz-card>
    </section>
  </ng-container>

  <ng-container *nzModalFooter>
    <div class="flex justify-end sm:justify-end">
      <a
        (nzOnCancel)="onCancelConfirm()"
        (nzOnConfirm)="confirm()"
        nz-popconfirm
        nzPopconfirmPlacement="bottom"
        nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
      >
        <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
      </a>
      <button
        (nzOnCancel)="cancel()"
        (nzOnConfirm)="onSubmit()"
        [disabled]="customerForm.invalid"
        nz-button nz-popconfirm
        nzPopconfirmPlacement="bottom" nzPopconfirmTitle="Are you sure you want to save the data?" nzType="primary">Update Customer
      </button>
    </div>
  </ng-container>
</nz-modal>
